import React, { memo } from 'react';
import { CustomTooltip } from 'src/uikit/Tooltip';
import { OrderStatusShort } from '../../services/fetchOrders';
import { IconSize, OrderStatus, UnknownOrderStatus } from './constants';

type OrderStatusIconProps = {
  status: OrderStatusShort;
  size?: IconSize;
  hideTooltip?: boolean;
  isOpen?: boolean;
  isWarning?: boolean;
  overlay?: boolean;
};

const OrderStatusIcon = (props: OrderStatusIconProps) => {
  const { status, size, hideTooltip, isOpen, isWarning, overlay } = props;
  const orderStatus = OrderStatus[status.statusCode] ?? UnknownOrderStatus;
  const { icon: Icon, title, fill } = orderStatus;

  return (
    <CustomTooltip
      title={
        !hideTooltip &&
        title + (status.description ? `, ${status.description}` : '')
      }
    >
      <Icon
        style={{
          width: `${size || IconSize.MEDIUM}px`,
          height: `${size || IconSize.MEDIUM}px`,
          fill: isOpen ? '#1CD1D1' : isWarning ? '#ef5243' : fill,
          ...(overlay && {
            background: 'white',
            borderRadius: '50%',
            border: '2px solid white',
          }),
        }}
      />
    </CustomTooltip>
  );
};

export const SimpleOrderStatusIcon = (
  props: Pick<OrderStatusIconProps, 'size' | 'status'>
) => {
  const { status, size } = props;
  const orderStatus = OrderStatus[status.statusCode] ?? UnknownOrderStatus;
  const { icon: Icon, fill } = orderStatus;

  return (
    <Icon
      style={{
        width: `${size || IconSize.MEDIUM}px`,
        height: `${size || IconSize.MEDIUM}px`,
        fill,
      }}
    />
  );
};

export const MemoizedOrderStatusIcon = memo(OrderStatusIcon);
export default OrderStatusIcon;
